import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { CurrentUserService } from './services/current-user.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

/** Pages for signed-in users: anyone else signs in first, then comes back here. */
export const authGuard: CanActivateFn = (
  route,
  state
): Observable<boolean | UrlTree> => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  return currentUserService.currentUser.pipe(
    map((user) => {
      if (user) {
        return true;
      }
      return router.createUrlTree(['/login'], { queryParams: { returnTo: state.url } });
    })
  );
};
